import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Tendina, UserCreateDto } from 'src/app/components/gestione-utenti/gestione-utenti.costants';
import { _ENDPOINT, _ENDPOINT_FWP } from 'src/app/endpoints/endpoint';
import { NetworkService } from 'src/app/services/network.service';
import { Utility } from 'src/app/utility/utility';
import { environment } from 'src/environments/environment';
import { UserCreationBillingAccountsOutputDto } from '../models/user.model';


@Injectable({
  providedIn: 'root'
})
export class UsersManagementService {
  destroy$ = new Subject<boolean>();
  constructor(private networkService: NetworkService, private toastr: ToastrManager, private spinner: NgxSpinnerService) { }

  loadUsers (){
    let urlUsers: string = environment.basePath + _ENDPOINT.getAllUsers;
    let data = {
      body: ''
    };
    data = Utility.createBodyForPostRequest(data, false);
    return this.networkService.post(urlUsers, data)
      .pipe(takeUntil(this.destroy$))
  }

  loadGroups(): Tendina[] {
      let tendinaGruppi: Tendina[] = [];
      let user = JSON.parse(localStorage.getItem('user') || '{}');
      if (user && user.group.groupName == 'BACK_OFFICE_ADMIN') {
        tendinaGruppi.push({ etichetta: 'OPERATOR ADMIN', valore: 'BACK_OFFICE_ADMIN' });
        tendinaGruppi.push({ etichetta: 'OPERATOR AGENT', valore: 'BACK_OFFICE_AGENT' });
      }
      else if (user && user.group.groupName == 'FLEET_MANAGER_ADMIN') {
        tendinaGruppi.push({ etichetta: 'FLEET MANAGER ADMIN', valore: 'FLEET_MANAGER_ADMIN' });
        tendinaGruppi.push({ etichetta: 'FLEET MANAGER', valore: 'FLEET_MANAGER' });
      }
      return tendinaGruppi;
  }


  GetUserBillingAccounts(group: string, operator: string) {
    this.spinner.show("sp1");
    let url: string = environment.basePath + _ENDPOINT_FWP.GetUserBillingAccounts;
    let data = Utility.createBodyForPostRequest({ group : group, operator : operator });

    return this.networkService.post(url, data)
        .pipe(takeUntil(this.destroy$))
  }

  signUpUser(user: UserCreateDto) {
    let urlSignUpUser: string = environment.basePath + _ENDPOINT.signUpUser;
    let data = Utility.createBodyForPostRequest(user);
    return this.networkService.post(urlSignUpUser, data)
      .pipe(takeUntil(this.destroy$));
  }

  updateUtente( dataUserUpdate: any, elemToUpdate: any,) {

    let dataRest: any = {
      dataUserUpdated: dataUserUpdate,
      elementoDaModificare: elemToUpdate
    }

    this.spinner.show("sp1");

    let urlUpdateUser: string = environment.basePath + _ENDPOINT.updateUserAttributes;


    let data = Utility.createBodyForPostRequest(dataRest);
    this.networkService.post(urlUpdateUser, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
          if (response && response.status) {
            let updateUserResponse = response;
            if (updateUserResponse && updateUserResponse.status == 'OK') {
              this.toastr.successToastr('User update successfully!', 'User update result', { 'animate': 'slideFromRight', 'timeout': '3000' });
            } else if (updateUserResponse &&  updateUserResponse.status == 'KO') {
              this.toastr.errorToastr(  updateUserResponse.message, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            }
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide("sp1");
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during the update user!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during the update user!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

          console.error(err);



        });

  }

   changePassword(userLoginDto : {newPassword : string, username : string}): void {
  
    let data = Utility.createBodyForPostRequest(userLoginDto);

    let urlLogin: string = environment.basePath + _ENDPOINT.resetPassword;
    this.networkService.post(urlLogin, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
          if (response && response.esito) {
         
            let loginResponseDto: any = response;
            if (loginResponseDto && loginResponseDto.esito && loginResponseDto.esito == "OK") {
           
              this.toastr.successToastr(loginResponseDto.msg, 'Change Password result', { 'animate': 'slideFromRight', 'timeout': '3000' });
            } else if (loginResponseDto && loginResponseDto.esito && loginResponseDto.esito == "KO") {
           
              this.toastr.errorToastr(loginResponseDto.msg, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            } else {
           
              this.toastr.errorToastr('Error during change password', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            }
          } else if (response && response.length && response.length > 0) {
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.toastr.errorToastr('Error during change password', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        },
        err => {
       
          console.error(err);
          this.toastr.errorToastr('Error during change password', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
        });;
  }

   deleteUser(username: string) {
    let urlDeleteUser: string = environment.basePath + _ENDPOINT.deleteUser;

    let data = Utility.createBodyForPostRequest(username, true);
    return this.networkService.post(urlDeleteUser, data)
      

  }

  getUser(username : any) {
    let urlGetUser: string = environment.basePath + _ENDPOINT.getUser;

    let data = Utility.createBodyForPostRequest(username);
    return this.networkService.post(urlGetUser, data)
      .pipe(takeUntil(this.destroy$))
  }

  
}
